import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {RecipientStopInfo} from "../model/rideInfo";
import "../styles/PudoInfo.css";
import {ReactComponent as ChevronDownIcon} from "../image/chevron-down.svg";

export function PudoInfo({stop}: {stop: RecipientStopInfo}) {
    const isRedirected = stop?.status === "REDIRECTED";
    const isDeliveredToPudo = stop?.status === "DELIVERED_TO_PUDO";
    const [showImages, setShowImages] = useState(false);
    const hasImages = stop.pudo?.images && stop.pudo.images.length > 0;

    const partnerName = stop.ordererName ?? stop.packageInfo?.senderInfo?.name ?? "";

    return (
        <div className="pudo-info">
            {isDeliveredToPudo && stop.pudo && (
                <>
                    <p className="pudo-subtitle">
                        <FormattedMessage id="pudo_name" />
                    </p>
                    <p className="pudo-name">{stop.pudo?.pudoName}</p>
                    <p>{stop.pudo?.location.placeName}</p>

                    {hasImages && (
                        <>
                            <button
                                className="toggle-image-button"
                                onClick={() => setShowImages(!showImages)}
                                data-cy="toggle-pudo-image"
                            >
                                <span className="toggle-image-label">
                                    <FormattedMessage
                                        id={showImages ? "hide_pudo_image" : "show_pudo_image"}
                                    />
                                    <ChevronDownIcon
                                        className={showImages ? "chevron rotated" : "chevron"}
                                    />
                                </span>
                            </button>

                            {showImages && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 8,
                                        paddingBottom: "12px",
                                    }}
                                >
                                    {stop.pudo?.images?.map((pudoImageUrl, index) => (
                                        <img
                                            key={index}
                                            src={pudoImageUrl}
                                            alt={`PUDO - ${index + 1}`}
                                            style={{maxWidth: "100%", borderRadius: 4}}
                                        />
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
            {(isRedirected || isDeliveredToPudo) && (
                <p className="pudo-subtitle">
                    <FormattedMessage
                        id="package_redirecting"
                        values={{ordererName: partnerName}}
                    />
                </p>
            )}
        </div>
    );
}
